import type { PropsWithChildren } from 'react';
import React from 'react';
import DetailsSection from './DetailsSection';
import Text from './Text';
import * as styles from '../css/details-text.css';
import { classNames } from '../utils';

interface Props {
    withBottomMargin?: boolean;
}

const DetailsText = ({ children, withBottomMargin }: PropsWithChildren<Props>) => (
    <DetailsSection className={classNames(withBottomMargin && styles.withBottomMargin)}>
        <Text>
            {children}
        </Text>
    </DetailsSection>
);

export default DetailsText;
